<template>
  <div class="col-11">
    <slot />
  </div>
</template>
